import React, { memo, useEffect, useState } from "react";
import { IconClose } from "../../assests/icons/ModalIcons";
import { store } from "../../ReduxTool/store/store";
// import { setAccordianError, setTabError } from "../../ReduxTool/Slice/Partner/EPC";
// import globalLayers from "../../Utils/EPCMaps/Maps/GlobaLMap";
import { setInformationModal } from "../../ReduxTool/Slice/Map/MapReducer";
import { useAppDispatch } from "../../ReduxTool/store/hooks";
import globalLayers from "../../Utils/CustomerMaps/Maps/GlobaLMap";
// import { switchView } from "../../lib/EPC/SwitchingMapLayers/SwitchMap";

export type MessageType = "success" | "error" | "warning" | "info";

interface CustomTooltipT {
  type?: MessageType;
  informationTitle?: string;
  informationContent: string;
  errorMessage?: string;
  duration?: number; // Auto-hide duration in milliseconds
  isVisible?:boolean
  setIsVisible?:React.Dispatch<React.SetStateAction<boolean>>
  isProgressbar?:boolean
  infoAutoHide?:boolean
  position?:'absolute'|'fixed'|'sticky'
}
const CustomTooltip: React.FC<CustomTooltipT> = ({type = "info",isProgressbar,position="absolute",informationTitle,informationContent,errorMessage,duration = 3000,infoAutoHide=false,isVisible,setIsVisible}) => {
  const [progress, setProgress] = useState(100),dispatch = useAppDispatch();
  useEffect(() => {
    if (!isVisible && !isProgressbar) return;
    if( !infoAutoHide) return;
    setProgress(100);
    const interval = setInterval(() => {
      setProgress((prev) => Math.max(prev - 100 / (duration / 100), 0));
    }, 100);
    const timer = setTimeout(() => {
        setIsVisible && setIsVisible(false);
        // store.dispatch(setAccordianError({}));
        // store.dispatch(setTabError({}));
    }, duration);
    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [isVisible, duration, setIsVisible,infoAutoHide,isProgressbar]);

  const typeStyles: Record<MessageType, string> = {
    success: "bg-green-100 border-green-500 text-green-800",
    error: "bg-red-100 border-red-500 text-red-800",
    warning: "bg-yellow-100 border-yellow-500 text-yellow-800",
    info: "bg-blue-100 border-blue-500 text-blue-800",
  };
  const postionStyles={
    absolute:"absolute top-0 left-1/2 transform -translate-x-1/2 z-20",
    fixed:"absolute top-[2px] left-1/2 transform -translate-x-1/2 z-10",
    sticky:"sticky top-0 left-0 z-10"
  }
  const handleCloseInformation = async () => {
    // globalLayers.activeView = "2D";
    // dispatch(setIs3dMap(false));
    // dispatch(setInformationModal({ state: false, title: "", content: "" }));

    const inputElement = document.querySelector<HTMLInputElement>(".esri-search__input");
    if (inputElement) inputElement.disabled = false;

    // if (!globalLayers.sketchLayers.graphics.length) return;
    
    let heightBase = 0;
    
    // await switchView(globalLayers.activeView, heightBase)
  };
  const onClose = () =>{
    if(position==="fixed"){
      dispatch(setInformationModal({ state: false, title: "", content: "" }))
    }
    setIsVisible && setIsVisible(false);
    // store.dispatch(setAccordianError({}));
        // store.dispatch(setTabError({}));
    if(globalLayers.activeView === "3D"){
      handleCloseInformation()
    }
  }
  return (
    <div className={`${postionStyles[position]} w-full max-w-screen-md p-4 rounded-lg shadow-lg transition-transform duration-500 ease-in-out ${isVisible ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0 pointer-events-none"} ${typeStyles[type]}`}>
      <div className="flex justify-between items-center">
        <section className="">
          {informationTitle && <strong className="font-semibold">{informationTitle}: </strong>}
          {informationContent && <span className="text-sm">{informationContent}</span>}
          {errorMessage && <p className="text-xs mt-2 font-medium text-red-600">Note: {errorMessage}</p>}
        </section>
        <button onClick={onClose} className="text-gray-600 hover:text-black transition-transform duration-300 hover:rotate-90"><IconClose/></button>
      </div>
      {/* Bottom Border Progress Indicator */}
      {isProgressbar && <div
        className={`absolute bottom-0 left-0 h-[14px] ${typeStyles[type]} rounded-bl-lg border-b-4 transition-all`}
        style={{ width: `${progress}%` }}
      ></div>}
    </div>
  );
};

export default memo(CustomTooltip);